// Maps internal status values to donor/public-facing wording where they differ.
const PUBLIC_STATUS_LABELS = {
  "Sanctuary Resident": "Living at our Kolad Sanctuary ❤",
};

export function getPublicStatusLabel(status) {
  return PUBLIC_STATUS_LABELS[status] || status;
}
